export default __webpack_public_path__ + "static/media/product_2.1.f1538554.jpg";